import { render } from "./LeaderboardNameGrid.vue?vue&type=template&id=163670b0"
import script from "./LeaderboardNameGrid.vue?vue&type=script&lang=js"
export * from "./LeaderboardNameGrid.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__